import { convertMapLocationResponse, convertDirection, convertDistanceMatrix } from './mapLocation';
import { LocationGroupTypes } from '../../types';
import { LocationGroupResponseTypes } from '../../types/response/locationGroup';

export const convertLocationGroupResponse = (
  item: LocationGroupResponseTypes,
  isSimplified = false
): LocationGroupTypes => {
  const direction = convertDirection(item.direction);
  const distanceMatrix = convertDistanceMatrix(item.distanceMatrix);

  const childGroups = (item.children || [])
    .map((i) => convertLocationGroupResponse(i, true))
    .sort((a, b) => a.orderIndex - b.orderIndex);

  const items = (item.locations || [])
    .map((i) => convertMapLocationResponse(i, item.id))
    .sort((a, b) => a.orderIndex - b.orderIndex);

  return {
    id: item.id,
    childGroups,
    childGroupIds: childGroups.map((i) => i.id),
    code: item.code,
    items,
    itemIds: items.map((i) => i.id),
    name: item.name,
    alias: item.alias,
    description: item.description,
    shortDescription: item.shortDescription,
    distanceMatrix,
    direction,
    backgroundImage: item.gallery && !!item.gallery.length ? item.gallery[0] : undefined,
    avatar: item.avatar,
    orderIndex: item.orderIndex,
    numberOfLocation: item.numberOfLocation,
    rating: item.rating,
    ratingDescription: item.ratingDescription,
    isSimplified,
    icon: item.icon,
  };
};
